import styled from 'styled-components';

export const StyledDiv = styled.div`
  width: 549px;
  display: flex;
  flex-direction: column;
  .input {
    margin-bottom: 20px;
    font-size: 13px;
  }
`;
export const SpacingBottom = {
  marginBottom: 20,
};
